import { render, staticRenderFns } from "./NoPic.vue?vue&type=template&id=dc53b046&scoped=true&"
import script from "./NoPic.vue?vue&type=script&lang=ts&"
export * from "./NoPic.vue?vue&type=script&lang=ts&"
import style0 from "./NoPic.vue?vue&type=style&index=0&id=dc53b046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc53b046",
  null
  
)

export default component.exports